import { render, staticRenderFns } from "./SaleManager.vue?vue&type=template&id=79223c87&scoped=true&"
import script from "./SaleManager.vue?vue&type=script&lang=js&"
export * from "./SaleManager.vue?vue&type=script&lang=js&"
import style0 from "./SaleManager.vue?vue&type=style&index=0&id=79223c87&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79223c87",
  null
  
)

export default component.exports